export default "__VITE_ASSET__CQATPr2Y__"